import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MasterService } from '../../../master/services/master.service';

@Injectable({ providedIn: 'root' })
export class TicketLookupsFacade {
  constructor(
    private masterService: MasterService
  ) { }

  loadContacts$(): Observable<any[]> {
    return this.masterService.getContacts();
  }
}
